<mee-file-preview-overlay-toolbar>
  <mat-icon (click)="dialogRef.close()">arrow_back</mat-icon>
  <div class="text-content">
    <div class="device-name">{{file.Creator?.FullName || ('fieldReports.noCreatorName' | translate) }}</div>
    <div class="date-comment-container">
      <span class="date">{{getTime(file.CreatedAtUtc)}}</span>
      <span class="separator" *ngIf="file.Comment"> | </span>
      <span class="comment" *ngIf="file.Comment">{{file.Comment | truncate:100}}</span>
    </div>
  </div>
</mee-file-preview-overlay-toolbar>
<div class="overlay-content"
     [@slideContent]="animationState"
     (@slideContent.start)="onAnimationStart($event)"
     (@slideContent.done)="onAnimationDone($event)">
  <div class="spinner-wrapper" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <video [class.hidden]="loading" (canplay)="onLoad($event)" [@fade]="loading ? 'fadeOut' : 'fadeIn'" controls>
    <source [src]="file.VideoRecord">
    {{'FilePreview.PreviewError' | translate}}
  </video>

</div>
